import { Spinner, makeStyles, tokens } from "@fluentui/react-components"

const useStyles = makeStyles({
    spinner: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: tokens.colorNeutralShadowAmbient,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
    }
});

type OverlaySpinnerProps = {
    open: boolean
    label?: string
}

export default function OverlaySpinner({ open, label }: OverlaySpinnerProps) {
    const styles = useStyles();

    return (
        <>
            {
                open && <Spinner className={styles.spinner} title={label ?? "Loading..."} />
            }
        </>
    )
}